import IntegrationsExtensions from './integrations-extensions.view';

export default IntegrationsExtensions;
